import { Icon } from 'components'

import styles from './Home.module.scss'
import { useTenant } from 'shared/hooks'

const Home = () => {
  const { tenant } = useTenant()

  return (
    <div className={styles.homeWrapper}>
      <Icon url={tenant?.brand.images.logo} name="ubisafe-logo" height={80} width={250} />
    </div>
  )
}

export default Home
